import React, { Component } from "react";

import Header from "../components/Header";
import FullPageImageOne from "../components/FullPageImage/fullPageImageOne";
import TextPage from '../components/TextPage/textPage';
import TextFullPage from '../components/TextFullPage/textfullpage';
import Contact from "../components/ContactPage/contact";

class IndexPage extends Component {
state = {
  menutogglewhite: false,
  logowhite: false
}

onMenuToggleWhite = val => {
  this.setState(prevState => {
    return { menutogglewhite: val };
  });
}

onLogoWhite = val => {
  this.setState(prevState => {
    return { logowhite: val };
  });
}
  render (props) {

    const home = {
        blockone: {
        head: '',
        body: 'Hi we’re id – an engineering and design studio. We translate emergent technologies into next generation products and services for humans through research, strategy and design.'
        }
    };
    const drivers = {
      blockone: {
      head: 'Technologies',
      body: 'Working at the intersection of design, technology and human interaction. Currently that’s applications of distributed ledgers, AI and IoT hardware that could meaningfully impact how we live, work and play.'
      },
      blocktwo: {
        head: 'Projects',
        body: 'Integrating with startups or progressive organisations to tackle new design and technical challenges. Synthesising human insights into creative strategies or longer-term project stewardship.'
      },
      blockthree: {
        head: 'Purpose',
        body: 'Using design as the fundament for positive interaction between social and technological systems. Engaging in ventures that tackle social challenges in new product categories and contexts.'
      }
    };
  
    const services = {
      blockone: {
      head: 'Strategy',
      body: 'We unlock creative potential by identifying actionable opportunities and building holistic business, product and brand strategies. We can help you define the direction ahead, accelerate decision making or steward ventures through their formative stages.',
      body2: <p id="Strategy" className="hidden" ><br/>Business strategy, product roadmaps, data strategy & analytics, brand platforms, technology frameworks.</p>
      },
      blocktwo: {
        head: 'Insight',
        body: 'Mapping complex scenarios through socially-centred research, we enable you to make informed decisions based on data and knowledge. We combine understanding of human behaviour and new technology to provide robust insights and evaluate prototypes with users.',
        body2: <p id="Insight" className="hidden" ><br/>Impact evaluations, touchpoint design, user workshop analyses, concept exploration, social trend & culture forecasts.</p>
      },
      blockthree: {
        head: 'Development',
        body: 'Conducting design development across physical and digital spaces we deliver innovative products and craft engaging user experiences. Through data insight from iterative prototyping we centre solutions around emerging behaviours and contexts.',
        body2: <p id="Development" className="hidden"><br/>Interaction design, UI & UX design, product R&D, system & service design, industrial design.</p>
      }
    };
  
    const process = {
      blockone: {
      head: 'Integrate',
      body: 'Through integration of empathic collaboration and speculative research we assemble insights and foresights that we embedd into project strategies.'
      },
      blocktwo: {
        head: 'Innovate',
        body: 'We architect, design and build tangible prototypes that go beyond purely technological solutions to deliver provocative and meaningful innovation.'
      },
      blockthree: {
        head: 'Evaluate',
        body: 'Our interdisciplinary approach enables us to add value to new propositions by evaluating their technical, strategic and human implications at all stages.'
      }
    };
  
    const team = {
      blockone: {
      head: '',
      body: <p>We are a team of strategists, designers and technologists based in London and Zurich.</p>,
      border: true,
      margin: true
      },
      blocktwo: {
        head: <p>Strategic Design, Director</p>,
        body: <p className="cursora">Andrew Slack<br/>BSc(Hons) MA MSc</p>,
        margin: true
        },
        blockthree: {
          head: <p>Interaction Design, Director</p>,
          body: <p>Bentley Farrington<br/>BA(Hons) MA MSc</p>,
          border: true,
          margin: true
          },
          blockfour: {
            head: <p>Data Engineering, Director</p>,
            body: <p>Pascal Jerome<br/>MPhys (Oxon)</p>,
            border: true,
            margin: true
            },
            blockfive: {
              head: <p>Industrial Design, Associate</p>,
              body: <p>Reto Togni<br/>BA MA MSc</p>,
              border: true,
              margin: true
              },
    };

    // <div className="w-1/3 mt-2 h-auto"><img className ="w-full h-auto" src={Andrew}/></div>
  
    const contact = {
      blockone: {
      head: '',
      body: <p>id Project Office Ltd.<br/>UK company no: 123456789</p>
      }
    };

  return (
  <div> 
    <Header 
    menuwhite={this.state.menutogglewhite}
    logowhite={this.state.logowhite}/>

  <div className="flex flex-col flex-1 w-full">
    <TextFullPage 
    title={<h1 className="font-light">A Strategic Project Office</h1>}
    content={home}/>

    <FullPageImageOne
    id="work"
    onMenuToggleWhite={this.onMenuToggleWhite}
    onLogoWhite={this.onLogoWhite} />

    <TextPage
    id="drives"
    title={<h1 className="font-light">What<br/>Drives Us</h1>}
    content={drivers}/>

    <TextPage
    id="services"
    title={<h1 className="font-light">Our<br/>Services</h1>}
    content={services}/>

    <TextPage
    id="process"
    title={<h1 className="font-light">Working<br/>Process</h1>}
    content={process}/>

    <TextPage 
    id="team"
    title={<h1 className="font-light">Our<br/>Team</h1>}
    content={team}
    mg={true}/>

    <Contact
    id="contact"
    onMenuToggleWhite={this.onMenuToggleWhite}
    onLogoWhite={this.onLogoWhite}
    />

  </div>
  </div> 

  )};
};

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js